// src\pages\PrincipalRegistration.js

import React, { useState } from "react";
import axios from "axios";
import "../styles/PrincipalRegistration.css";

const PrincipalRegistration = () => {
  const [rollNumber, setRollNumber] = useState("");
  const [schoolData, setSchoolData] = useState(null);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [principalEmail, setPrincipalEmail] = useState("");
  const [isRegistered, setIsRegistered] = useState(false);

  const fetchSchoolData = async (rollNumber) => {
    try {
      const response = await axios.get(
        `https://ghrianghraffy.com/auth/get-school-data/${rollNumber}`
      );
      setSchoolData(response.data);
      setPrincipalEmail(response.data.principal_email);
      setEmail(response.data.principal_email);
      setMessage("");
    } catch (error) {
      setSchoolData(null);
      setPrincipalEmail("");
      setEmail("");
      setMessage("School not found. Please check the Roll Number.");
    }
  };

  const handleRegister = async () => {
    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage("Invalid email format. Please enter a valid email address.");
      return;
    }

    try {
      const response = await axios.post("https://ghrianghraffy.com/auth/principal-registration", {
        email,
        role: "PRINCIPAL",
        roll_number: rollNumber,
      });
      setMessage(response.data.message);
      setIsRegistered(true);
    } catch (error) {
      setMessage(
        error.response?.data?.detail || "Failed to register. Please try again."
      );
    }
  };

  return (
    <div className="principal-registration">
      <h1 className="registration-title">Principal Registration</h1>

      {message && (
        <p className={`message ${message.includes("Failed") ? "error" : "success"}`}>
          {message}
        </p>
      )}

      <div className="form-group">
        <label>Roll Number</label>
        <input
          type="text"
          className="input-field"
          placeholder="Enter your School's Roll Number"
          value={rollNumber}
          onChange={(e) => {
            const newRollNumber = e.target.value;
            setRollNumber(newRollNumber);
            if (newRollNumber.length >= 5) {
              fetchSchoolData(newRollNumber);
            } else {
              setSchoolData(null);
              setPrincipalEmail("");
              setEmail("");
              setMessage("");
            }
          }}
        />
      </div>

      {schoolData && (
        <div className="school-details">
          <p><strong>School Name:</strong> {schoolData.official_name}</p>
          <p><strong>Address:</strong> {schoolData.address_line_1}, {schoolData.county_description}</p>
          <p><strong>Eircode:</strong> {schoolData.eircode}</p>
          <p><strong>Phone:</strong> {schoolData.phone_no}</p>
          <p><strong>Principal:</strong> {schoolData.principal_name}</p>
          <p><strong>Principal Email:</strong> {principalEmail}</p>
          <p><strong>Enrolment:</strong> {schoolData.enrolment_quantity}</p>
          {schoolData.school_website && (
            <p>
              <strong>School Website:</strong>{" "}
              <a href={schoolData.school_website} target="_blank" rel="noopener noreferrer" className="school-website-link">
                {schoolData.school_website}
              </a>
            </p>
          )}
          {schoolData.website_tech_used && (
            <p><strong>Website Technology:</strong> {schoolData.website_tech_used}</p>
          )}
        </div>
      )}

      <div className="form-group">
        <label>Email</label>
        <div className="input-wrapper">
          <input
            type="email"
            className="input-field"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <span className="tooltip">The email above will be used for everything related your GhrianGhraffy account. You can overwrite this email address with whichever email address is most convenient for you. When you&apos;re ready to proceed, click on the Register button.</span>
        </div>
      </div>
      <button
        className="register-button"
        onClick={handleRegister}
        disabled={!rollNumber || !email || !schoolData || isRegistered}
        title={
          isRegistered
            ? "You are already registered."
            : !rollNumber || !email || !schoolData
              ? "Please complete all fields."
              : ""
        }
      >
        {isRegistered ? "Registered ✅" : "Register"}
      </button>
    </div>
  );
};

export default PrincipalRegistration;